<template>
  <v-dialog v-model="dialog" v-if="dialog" max-width=600 scrollable>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Add Payment Method
      </v-card-title>
      <v-card-text>
        <v-checkbox label="Make this the default Payment Method" v-model="paymentMethod.default"></v-checkbox>
        <credit-card-input v-if="paymentMethod.method_type == 'CreditCard'"
                           :credit-card="paymentMethod.credit_card"/>
        <br>
        <b class="semibold">Billing Info</b>
        <contact-input
          :contact="paymentMethod.credit_card"
          @update-contact="paymentMethod.credit_card = $event"
        />
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-btn color="primary" @click="$emit('save', paymentMethod)">Save</v-btn>
        <v-btn flat @click="$emit('cancel')">Cancel</v-btn>
        <v-spacer/>
        <v-btn flat color='red' @click="$emit('delete', paymentMethod.id)">Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ContactInput from '../widgets/contact-input'
import CreditCardInput from '../widgets/credit-card-input'

export default {
  components: {
    'contact-input': ContactInput,
    'credit-card-input': CreditCardInput
  },

  props: {
    paymentMethod: Object,
    value: Boolean
  },

  computed: {
    dialog: {
      get () {
        return this.value
      },

      set (value) {
        if (value === false) this.$emit('cancel')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// payment-method-form.vue?ee4fd686